// THis will check things like the paragraph headers and alignments

import { doc, setDoc } from "firebase/firestore";
import { DEFAULT_EVALUATION_METRIC_VERSION_ID } from "~/types/EvaluationMetric";

export const useDocumentFormattingDiagnostics = (documentId: string) =>
  defineStore(`/document/${documentId}/diagnostics/formatting`, () => {
    const submittedDocumentStore = useSubmittedDocumentStore(documentId);
    const { revision } = storeToRefs(submittedDocumentStore);

    const hasPassedDiagnostics = ref(false);
    const diagnosticsErrorMessage = ref<string | undefined>(undefined);

    const isRunning = ref(false);
    const runDiagnostics = async (diagnosticsConfig: any) => {
      isRunning.value = true;

      await Promise.all(
        diagnosticsConfig.diagnostics.map(async (diagnostic: any) => {
          return runDiagnostic(diagnostic);
        })
      );

      // Check if all the diagnostics have undefined erro
      if (
        diagnosticsConfig.diagnostics.every(
          (diagnostic: any) => diagnostic.errorMessage == undefined
        )
      ) {
        hasPassedDiagnostics.value = true;
        ``;
        diagnosticsErrorMessage.value = undefined;
      } else {
        hasPassedDiagnostics.value = false;
        diagnosticsErrorMessage.value = diagnosticsConfig.defaultErrorMessage;
      }

      isRunning.value = false;
    };

    const runDiagnostic = async (diagnostic: any) => {
      if (revision.value == undefined || revision.value.id == undefined) return;

      diagnostic.isEvaluationRunning = true;

      const db = useFirestore();

      const resultsRef = doc(
        db,
        `/documents/${documentId}/revisions/${revision.value.id}/evaluationResults/${diagnostic.metricId}`
      );

      await setDoc(resultsRef, {
        status: EvaluationResultsStatus.evaluating,
        createdOnTimestamp: new Date().getTime(),
        lastUpdatedTimestamp: new Date().getTime(),
        versionId: DEFAULT_EVALUATION_METRIC_VERSION_ID,
      });

      // Wait for 2 seconds

      const response = await $fetch(`/api/document/metric/evaluate`, {
        method: "POST",
        headers: await useApiHeaders(),
        body: {
          documentId: documentId,
          revisionId: revision.value.id,
          metricId: diagnostic.metricId,
          runInBackground: false,
          urgent: true,
        },
      });

      const evaluationResults = response as EvaluationResults;
      const criteria = evaluationResults.evaluationResult[0];

      if (criteria.relevantInstances.length == 0) {
        diagnostic.errorMessage =
          diagnostic.errorCodeMap["no-relevant-instances"];
        diagnostic.isEvaluationRunning = false;
        return;
      }

      if (diagnostic.type == "paragraph") {
        // Get the paragrap hfrom the relevant instance token
        const firstToken = criteria.relevantInstances[0].tokens[0];
        const firstTokenId = firstToken.id;
        const firstTokenGlobalPosition =
          useDocumentTokenIdPositionMapStore(
            documentId
          ).tokenGlobalPositionFromId(firstTokenId);
        const tokenStore = useParagraphTokenStore(
          documentId,
          firstTokenGlobalPosition
        );
        const paragraphId = tokenStore.paragraphId;

        if (paragraphId == undefined) {
          diagnostic.errorMessage =
            diagnostic.errorCodeMap["no-relevant-instances"];
          diagnostic.isEvaluationRunning = false;
          return;
        }

        const paragraphStore = useDocumentParagraphStore(
          documentId,
          paragraphId
        );
        const paragraph = paragraphStore.paragraph;

        if (paragraph == undefined) {
          diagnostic.errorMessage =
            diagnostic.errorCodeMap["no-relevant-instances"];
          diagnostic.isEvaluationRunning = false;
          return;
        }

        if (diagnostic.alignment != undefined) {
          if (paragraph.formatting.alignment != diagnostic.alignment) {
            diagnostic.errorMessage =
              diagnostic.errorCodeMap["incorrect-alignment"];
            diagnostic.isEvaluationRunning = false;
            return;
          }
        }
      }

      diagnostic.isEvaluationRunning = false;
    };

    return {
      isRunning,
      hasPassedDiagnostics,
      diagnosticsErrorMessage,
      runDiagnostics,
    };
  });
